import _ from 'lodash';

import styles from './styles.module.scss';

interface Props {
  className?: string;
  size: number;
  index: number;
}

export default function Indicator(props: Props) {
  const { className = '', size = 0, index = 0 } = props;
  return <div className={`${styles.container} ${className}`}>
    {_.range(size).map(i => (
      <div key={i} className={`${styles.item} ${styles.item} ${i == index ?  styles.active: ''}`} />
    ))}
  </div>;
}